let _configData = window._env_ || {};

const _env = "dev"; // stg, uat
const vendor = process.env.REACT_APP_CLIENT || "vd004";

export const setConfig = (config) => (_configData = config);

export const getConfig = () => _configData;

// [NOTE] add language , 新增語系
export const LocaleDash = {
  en_US: "en-us",
  /**
   * 印尼文
   */
  id_ID: "id-id",
  /**
   * 馬來西亞
   */
  ms_MY: "ms-my",
  /**
   * 越南
   */
  vi_VN: "vi-vn",
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  ja_JP: "ja-jp",
  ko_KR: "ko-kr",
  /**
   * 泰文
   */
  th_TH: "th-th",
  /**
   * 印度文
   */
  hi_IN: "hi-in",
  /**
   * 葡萄牙文
   */
  pt_PT: "pt-pt",
  /**
   * 西文
   */
  es_ES: "es-es",
  en_IN: "en-in",
  en_PH: "en-ph",
  tl_PH: "tl-ph",
};

const APP_DOWNLOAD_MAP_FAKE = {
  webButton: true,
  android: {
    incoming: false,
    login: false,
    urls: [
      {
        appType: 4,
        url: "",
        packageType: 0,
        downloadLinks: ["http:platform.apk"],
        appPackageType: 9,
      },
      {
        appType: 8,
        url: "",
        packageType: 0,
        downloadLinks: [
          "https://app.pejihckw05113.app/appdownload/android/061e69008-stg-release-5.33.0-27571.apk",
        ],
        appPackageType: 8,
      },
      // {
      //   appType: 16,
      //   url: "",
      //   packageType: 1,
      //   downloadLinks: ["http:andriod.google.play"],
      //   appPackageType: 13,
      // },
    ],
  },
  ios: {
    incoming: false,
    login: false,
    urls: [
      {
        appType: 8,
        url: "",
        packageType: 1,
        downloadLinks: [
          "itms-services://?action=download-manifest&url=https://app1.36uqu13k.app/appdownload/ios/vd004Prod09191411V4.9.8B230919A2.plist",
        ],
        appPackageType: 1,
      },
      {
        appType: 16,
        url: "",
        packageType: 1,
        downloadLinks: [
          "itms-services://?action=download-manifest&url=https://app1.36uqu13k.app/appdownload/ios/vd004Prod09191411V4.9.8B230919A2.plist",
        ],
        appPackageType: 12,
      },
      {
        appType: 0,
        url: "",
        packageType: 3,
        downloadLinks: [
          "itms-services://?action=download-manifest&url=https://app1.36uqu13k.app/appdownload/ios/vd004Prod09191411V4.9.8B230919A2.plist",
        ],
        appPackageType: 7,
      },
      {
        appType: 16,
        url: "",
        packageType: 1,
        downloadLinks: ["ios.testflight"],
        appPackageType: 11,
      },
    ],
  },
};

const SYS_CONFIG_FAKE = {
  defaultCurrency: "CNY",
  currencies: [
    "CNY",
    "IDR",
    "MYR",
    "VND",
    "HKD",
    "THB",
    "KRW",
    "INR",
    "USD",
    "JPY",
    "BTC",
    "ETH",
    "LTC",
    "USDT_ERC20",
    "DOGE",
    "BCH",
    "DASH",
    "ETC",
    "USDT_TRC20",
    "AAVE_ERC20",
    "DAI_ERC20",
    "UNI_ERC20",
    "WBTC_ERC20",
    "USDC_ERC20",
    "TRX",
  ],
  defaultLocal: "zh-cn",
  // [NOTE] add language , 新增語系
  locales: [
    "ms-my",
    "zh-cn",
    "vi-vn",
    "en-us",
    "id-id",
    "hi-in",
    "th-th",
    "zh-hk",
    "ko-kr",
    "ja-jp",
    "pt-pt",
    "en-in",
    "en-ph",
    "tl-ph",
  ],
  cryptoCurrencies: [
    "BTC",
    "ETH",
    "LTC",
    "USDT_ERC20",
    "DOGE",
    "BCH",
    "DASH",
    "ETC",
    "USDT_TRC20",
    "AAVE_ERC20",
    "DAI_ERC20",
    "UNI_ERC20",
    "WBTC_ERC20",
    "USDC_ERC20",
    "TRX",
  ],
};

const developmentConfigs = (env) => {
  const isDev = env === "dev";
  const isStg = env === "stg";
  const isUat = env === "uat";
  const oldApiUri = `tiger-api.inno${env}.site`;
  const platformUri =
    isDev || isStg || isUat ? "tiger-dev.servicelab.sh" : oldApiUri;

  switch (env) {
    case "dev":
    case "stg":
    case "uat":
      return {
        PLATFORM_URL: `https://en-${vendor}-universe-portal.inno${env}.site`,
        PLATFORM_API_URL: `https://${platformUri}/platform`,
        FE_CDN_URL: "https://fe-source.dev.mppwr.com",
        DEPLOY_ENV: env,
        RELAY_URL: `https://en-${vendor}-tiger-relay.inno${env}.site`,
        APP_DOWNLOAD_MAP: APP_DOWNLOAD_MAP_FAKE,
        SYS_CONFIG: SYS_CONFIG_FAKE,
        SYSTEM: {
          lang: "zh_HK",
        },
        VENDERID: vendor,
      };
    default: {
    }
  }
};

if (!window._env_) setConfig(developmentConfigs(_env));
